import { Stack, styled } from '@mui/material'

export const StyledRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%',
  '& .makeStyles-autocompleteListWrap-322 .MuiAutocomplete-option[aria-selected="true"]::after': {
    display: 'none',
  },
  '&:hover': {
    '& svg > rect': {
      stroke: '#000000',
    },
  },
  '& .PrivateSwitchBase-root-152': {
    padding: theme.spacing(0.5, 0.5, 0.5, 0.5),
    margin: theme.spacing(0.7, 2, 0.7, 0),
  },
  '& .MuiIconButton-colorSecondary': {
    backgroundColor: 'transparent',
  },
}))
